import { CLASS_NAMES } from '../../utils/constants'
import Explosion from './Explosion'
import Fallable from './Fallable'

export default class Boulder extends Fallable {
  constructor(id, level) {
    super({
      id,
      isRigid: false,
      isBreakable: true,
      isFlat: false,
      isPickable: false,
      isCrushable: false,
      level
    })
    this.strength = 5
  }

  runningOver(el) {
    if(el.classes.includes("Barrel")) {
      this.inactive = true
    }
  }
  overrunBy(el) {
    if(!el || el?.isClass(Explosion)) {
      this.alien.visible = false
      this.alien.destroy()
      this.inactive = true
    }
  }
}
Boulder.className = CLASS_NAMES.BOULDER
